(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/campaign-info.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/campaign-info.js');

'use strict';

const date = svs.utils.date;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  openCampaignApi = _svs$numbergames.campaign.openCampaignApi,
  AndraChansenRowBanner = _svs$numbergames.ReactAndraChansenBanners.AndraChansenRowBanner;
const _svs$gamePackage$redu = svs.gamePackage.redux.selectors,
  selectGame = _svs$gamePackage$redu.selectGame,
  selectDraw = _svs$gamePackage$redu.selectDraw;
const CampaignInfo = _ref => {
  let uniqueId = _ref.uniqueId;
  const game = useSelector(state => selectGame(state, uniqueId));
  const draw = useSelector(state => selectDraw(state, game.productItsId));
  const campaign = openCampaignApi.getCampaign(game.productId, {
    draw
  });
  const numberOfChances = openCampaignApi.calculateChances(game.productId, {
    wager: game,
    draw
  });
  if (!campaign || !numberOfChances) {
    return null;
  }
  if (productMapping.isLotto(game.productItsId)) {
    return React.createElement(AndraChansenRowBanner, {
      chances: numberOfChances,
      endDate: campaign.endDate,
      isAndraChansenPeriodic: openCampaignApi.isPeriodicCampaign(game.productId, {
        draw
      }),
      shouldShowIcon: true
    });
  }
  return React.createElement("div", null, React.createElement("span", null, productMapping.getProductName(game.productItsId), " kampanj"), " ", React.createElement("span", {
    className: "f-medium"
  }, campaign.campaignName), React.createElement("br", null), "Kampanjperiod: ", date.ShortDateAndTime(campaign.startDate, true, false), "-", date.ShortDateAndTime(campaign.endDate, true, false), React.createElement("br", null), "Dragning: ", date.ShortDateAndTime(campaign.drawDate, true, false), React.createElement("p", {
    className: "f-medium"
  }, numberOfChances, " ", numberOfChances > 1 ? 'chanser' : 'chans'));
};
svs.gamePackage.components.CampaignInfo = CampaignInfo;

 })(window);